import classNames from 'classnames'
import React from 'react'
import {Tabs as TabsUI} from 'wix-ui-tpa/cssVars'
import {classes} from './tabs.st.css'

export const Tabs = props => (
  <TabsUI {...props} className={classNames(classes.root, {[classes.mobile]: props.mobile})} />
)
